import { F0Box, F0Dialog, F0Text } from '@factorialco/f0-react'

import i18n from 'modules/core/lib/i18n'

interface DeleteExpensableModalProps {
  isBulk?: boolean
  onConfirm: () => void
  onClose: () => void
}

const DeleteExpensableModal = ({
  isBulk = false,
  onConfirm,
  onClose,
}: DeleteExpensableModalProps) => {
  const handleConfirm = () => {
    onClose()
    onConfirm()
  }

  return (
    <F0Dialog
      isOpen
      width="sm"
      title={
        isBulk
          ? i18n.t('expenses_v2.list.actions.modal.bulk_delete.title')
          : i18n.t('expenses_v2.list.actions.modal.delete.title')
      }
      primaryAction={{
        label: i18n.t('expenses_v2.buttons.delete'),
        onClick: handleConfirm,
      }}
      secondaryAction={{
        label: i18n.t('expenses_v2.buttons.cancel'),
        onClick: onClose,
      }}
      onClose={onClose}
    >
      <F0Box flexDirection="column" alignItems="center" gap="md">
        <F0Text
          variant="body"
          content={
            isBulk
              ? i18n.t('expenses_v2.list.actions.modal.bulk_delete.description')
              : i18n.t('expenses_v2.list.actions.modal.delete.description')
          }
        />
      </F0Box>
    </F0Dialog>
  )
}

export default DeleteExpensableModal
